import React from 'react';

function Header() {
  return (
    <header className="tc-inner-header-style1" style={{ paddingTop: '120px' }}>
      <div className="container">
        <div className="info col-lg-7">
          <h1 className="js-title"> Blogs </h1>
          <div className="text fsz-18 color-666">
             Latest blogs, design ideas, industry trends, and expert perspectives
  from the world of architecture and interior design.
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
